export default "__VITE_ASSET__BbknhAAd__"